module.exports = __webpack_public_path__ + "assets/img/mastercard.ed5386a5.svg";